  <template>
  <v-main id="app2" class="monsterrat">
    <v-layout fill-height>
      <v-row>
        <v-col
          lg="6"
          cols="12"
          v-show="!swipeDirection"
          v-touch="{
            left: () => swipe('Left'),
            right: () => swipe('Right'),
          }"
        >
          <v-card elevation="0" height="100%">
            <LevelTest class="pb-lg-10" />
          </v-card>
        </v-col>
        <v-col
          class="d-lg-flex"
          lg="6"
          cols="12"
          v-show="swipeDirection"
          v-touch="{
            left: () => swipe('Left'),
            right: () => swipe('Right'),
          }"
        >
          <v-card elevation="0" class="py-10 px-10" height="100%" width="100%">
            <v-row align="center">
              <v-col>
                <div class="font-36 fw-medium">Level Test</div>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-btn
                  depressed
                  outlined
                  large
                  @click="reset()"
                  style="text-transform: none"
                  class="font-18"
                >
                  Reset
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-row>
                  <v-col>
                    <div class="font-18 fw-light">Name</div>
                  </v-col>
                  <v-col>
                    <div class="font-18 fw-medium">
                      {{ StudentData.name ? StudentData.name : "[class name]" }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row align="center">
                  <v-col>
                    <div class="font-18 fw-light">Attendance</div>
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="attendance"
                      class="font-18 fw-medium mt-0 pt-0"
                      :items="items"
                      item-text="category"
                      item-value="value"
                      single-line
                      :value="absent()"
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-row>
                  <v-col>
                    <div class="font-18 fw-light">Class Speed</div>
                  </v-col>
                  <v-col>
                    <div class="font-18 fw-medium">
                      {{
                        StudentData.speed ? StudentData.speed : "[class speed]"
                      }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row align="center">
                  <v-col>
                    <div class="font-18 fw-light">Total Score</div>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :rules="rules"
                      hide-details="auto"
                      class="font-18 fw-medium mt-0 pt-0"
                      readonly
                      v-model="totalscores"
                    >
                      <v-input />
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-row>
                  <v-col>
                    <div class="font-18 fw-light">Time</div>
                  </v-col>
                  <v-col>
                    <div class="font-18 fw-medium">
                      {{ StudentData.time ? StudentData.time : "[class time]" }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row align="center">
                  <v-col>
                    <div class="font-18 fw-light">Level</div>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :rules="rules"
                      hide-details="auto"
                      class="font-18 fw-medium mt-0 pt-0"
                      readonly
                      :value="levelResult()"
                    >
                      <v-input full-width="30" />
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-stepper v-model="e1" alt-labels flat>
                  <v-stepper-header stepper-width>
                    <v-stepper-step step="1" @click="e1 = 1" class="font-10">
                      Feedback
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="2" @click="e1 = 2" class="font-10">
                      Score
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="3" @click="e1 = 3" class="font-10">
                      Comment
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-card flat>
                    <v-stepper-items>
                      <v-form ref="form">
                        <v-stepper-content step="1">
                          <v-flex>
                            <v-row>
                              <v-col>
                                <div class="font-18 fw-medium">
                                  Sentence Correction
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-row no-gutters align="center" class="mb-5">
                                  <v-col cols="1">
                                    <v-icon large color="red">
                                      mdi-close
                                    </v-icon>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light mt-0 pt-0"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="mdi_close1"
                                      placeholder="Incorrect sentence from the student"
                                      hide-details="auto"
                                    >
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row no-gutters align="center">
                                  <v-col cols="1">
                                    <v-icon large color="green">
                                      mdi-check
                                    </v-icon>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light mt-0 pt-0"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="mdi_check1"
                                      placeholder="Your correction"
                                      hide-details="auto"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-row no-gutters align="center" class="mb-5">
                                  <v-col cols="1">
                                    <v-icon large color="red">
                                      mdi-close
                                    </v-icon>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light mt-0 pt-0"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="mdi_close2"
                                      placeholder="Incorrect sentence from the student"
                                      hide-details="auto"
                                    >
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row no-gutters align="center">
                                  <v-col cols="1">
                                    <v-icon large color="green">
                                      mdi-check
                                    </v-icon>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light mt-0 pt-0"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="mdi_check2"
                                      placeholder="Your correction"
                                      hide-details="auto"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-row class="mt-10">
                              <v-col>
                                <div class="font-18 fw-medium">
                                  Words to be Careful With
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-row no-gutters align="center">
                                  <v-col sm="2">
                                    <div class="font-14 fw-light">
                                      1.
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light"
                                      :error-messages="
                                        errorword1 && attendance != 'absent'
                                          ? 'No word found. Please check the spelling.'
                                          : ''
                                      "
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="word1"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col>
                                <v-row no-gutters align="center">
                                  <v-col sm="2">
                                    <div class="font-14 fw-light">
                                      2.
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      :readonly="
                                        attendance == 'absent' ? true : false
                                      "
                                      class="font-14 fw-light"
                                      :rules="
                                        attendance == 'absent' ? '' : inputRules
                                      "
                                      v-model="word2"
                                      :error-messages="
                                        errorword2 && attendance != 'absent'
                                          ? 'No word found. Please check the spelling.'
                                          : ''
                                      "
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 white--text font-18"
                                  @click="(e1 = 2), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                >
                                  Next
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-flex>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                          <v-flex>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Score
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-expansion-panels flat>
                                  <v-expansion-panel>
                                    <v-expansion-panel-header
                                      class="font-14 fw-light"
                                    >
                                      Pronunciation
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-radio-group
                                        v-model="pronun"
                                        :rules="radioRules"
                                        :error-messages="
                                          listgroup1error
                                            ? 'Item is Required! Please Select One Answer'
                                            : ''
                                        "
                                        required
                                      >
                                        <v-card
                                          color="#D9F3FF"
                                          elevation="0"
                                          class="px-5 py-5"
                                        >
                                          <v-row>
                                            <v-col>
                                              <v-radio
                                                v-for="pro in Pronunciation"
                                                :key="pro.title"
                                                :label="pro.title"
                                                :value="pro.value"
                                                v-on:click="scorepro(pro.value)"
                                                class="font-14 fw-light"
                                              >
                                              </v-radio>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-radio-group>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                  <v-expansion-panel>
                                    <v-expansion-panel-header
                                      class="font-14 fw-light"
                                    >
                                      Grammar
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-radio-group
                                        v-model="gram"
                                        :rules="radioRules"
                                        :error-messages="
                                          listgroup2error
                                            ? 'Item is Required! Please Select One Answer'
                                            : ''
                                        "
                                        required
                                      >
                                        <v-card
                                          color="#D9F3FF"
                                          elevation="0"
                                          class="px-5 py-5"
                                        >
                                          <v-row>
                                            <v-col>
                                              <v-radio
                                                v-for="gra in Grammar"
                                                :key="gra.title"
                                                :label="gra.title"
                                                :value="gra.value"
                                                v-on:click="scoregra(gra.value)"
                                                class="font-14 fw-light"
                                              ></v-radio>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-radio-group>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                  <v-expansion-panel>
                                    <v-expansion-panel-header
                                      class="font-14 fw-light"
                                    >
                                      Vocabulary
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-radio-group
                                        v-model="volca"
                                        :rules="radioRules"
                                        :error-messages="
                                          listgroup3error
                                            ? 'Item is Required! Please Select One Answer'
                                            : ''
                                        "
                                        required
                                      >
                                        <v-card
                                          color="#D9F3FF"
                                          elevation="0"
                                          class="px-5 py-5"
                                        >
                                          <v-row>
                                            <v-col>
                                              <v-radio
                                                v-for="vol in Vocabulary"
                                                :key="vol.title"
                                                :label="vol.title"
                                                :value="vol.value"
                                                v-on:click="scorevol(vol.value)"
                                                class="font-14 fw-light"
                                              >
                                              </v-radio>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-radio-group>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                  <v-expansion-panel>
                                    <v-expansion-panel-header
                                      class="font-14 fw-light"
                                    >
                                      Comprehension
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-radio-group
                                        v-model="compre"
                                        :rules="radioRules"
                                        :error-messages="
                                          listgroup4error
                                            ? 'Item is Required! Please Select One Answer'
                                            : ''
                                        "
                                        required
                                      >
                                        <v-card
                                          color="#D9F3FF"
                                          elevation="0"
                                          class="px-5 py-5"
                                        >
                                          <v-row>
                                            <v-col>
                                              <v-radio
                                                v-for="com in Comprehension"
                                                :key="com.title"
                                                :label="com.title"
                                                :value="com.value"
                                                v-on:click="scorecom(com.value)"
                                                class="font-14 fw-light"
                                              >
                                              </v-radio>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-radio-group>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                  <v-expansion-panel>
                                    <v-expansion-panel-header
                                      class="font-14 fw-light"
                                    >
                                      Fluency
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-radio-group
                                        v-model="fluen"
                                        :rules="radioRules"
                                        :error-messages="
                                          listgroup5error
                                            ? 'Item is Required! Please Select One Answer'
                                            : ''
                                        "
                                        required
                                      >
                                        <v-card
                                          color="#D9F3FF"
                                          elevation="0"
                                          class="px-5 py-5"
                                        >
                                          <v-row>
                                            <v-col>
                                              <v-radio
                                                v-for="flu in Fluency"
                                                :key="flu.title"
                                                :label="flu.title"
                                                :value="flu.value"
                                                v-on:click="scoreflu(flu.value)"
                                                class="font-14 fw-light"
                                              >
                                              </v-radio>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-radio-group>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 font-18"
                                  @click="(e1 = 1), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  outlined
                                  width="50%"
                                >
                                  Previous
                                </v-btn>
                              </v-col>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 white--text font-18"
                                  @click="(e1 = 3), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  width="50%"
                                >
                                  Next
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-flex>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                          <v-flex>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Teacher’s Message to the Student
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  :readonly="
                                    attendance == 'absent' ? true : false
                                  "
                                  :rules="
                                    attendance == 'absent'
                                      ? ''
                                      : [
                                          (v) =>
                                            (v || '').length <= 500 ||
                                            'Description must be 500 characters or less',
                                          (v) =>
                                            (v || '').length >= 1 ||
                                            'Description must be 500 characters or less',
                                        ]
                                  "
                                  :counter="500"
                                  v-model="comment"
                                  auto-grow
                                  placeholder="Please type your comment and message to the student here."
                                  class="font-14 fw-light"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <div class="font-14 fw-medium">
                                  Memo
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  rows="1"
                                  auto-grow
                                  :rules="inputRules"
                                  class="font-14 fw-light"
                                  v-model="memo"
                                  placeholder="Please write about any issues encountered in the class or special requests of the student here."
                                  :error-messages="
                                    errormemo && attendance == 'absent'
                                      ? 'Item is Required'
                                      : ''
                                  "
                                ></v-textarea>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 font-18"
                                  @click="(e1 = 2), scrollTop()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  outlined
                                  width="80%"
                                >
                                  Previous
                                </v-btn>
                              </v-col>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  @click="openDialog()"
                                  color="#02A9F4"
                                  class="ma-2 font-18"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important; background-color: #DEF5FF"
                                  outlined
                                  width="80%"
                                >
                                  Preview
                                </v-btn>
                              </v-col>
                              <v-col class="d-flex justify-center">
                                <v-btn
                                  color="#02A9F4"
                                  class="ma-2 white--text font-18"
                                  @click="submit()"
                                  elevation="0"
                                  large
                                  style="text-transform: none !important"
                                  width="80%"
                                >
                                  Submit
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-flex>

                          
                                <StudentEvaluation
                                  v-show="attendance == 'absent' ? false : true"
                                  :prev-status="prevStat"
                                  :student-name="StudentData.name"
                                  :audio-one="audioVal1"
                                  :audio-two="audioVal2"
                                  :total-score="totalscores"
                                  :pronun-val="proVal"
                                  :gram-val="graVal"
                                  :voca-val="volVal"
                                  :com-val="comVal"
                                  :flu-val="fluVal"
                                  :mdi-close1="mdi_close1"
                                  :mdi-check1="mdi_check1"
                                  :mdi-close2="mdi_close2"
                                  :mdi-check2="mdi_check2"
                                  :word-one="word1"
                                  :word-two="word2"
                                  :teacher-comment="comment"
                                  ref="leveltestDialog"
                                />

                                <!-- <div
                                  class="text-h3"
                                  v-show="attendance == 'absent' ? true : false"
                                >
                                  Data Successfully Saved!
                                </div>
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="dialogshow = false"
                                  class="white--text"
                                >
                                  Close
                                </v-btn>
                              </v-card-actions> -->
                          


                        </v-stepper-content>
                      </v-form>
                    </v-stepper-items>
                  </v-card>
                </v-stepper>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-main>
</template>
<script>
import LevelTest from "../leveltest/leveltest.vue";
import StudentEvaluation from "../evaluations/StudentEvaluationNew.vue";
import Vue from "vue";
import axios from "axios";
Vue.use(axios);
export default {
  name: "Form",
  components: {
    LevelTest,
    StudentEvaluation,
  },
  data: () => {
    return {
      alert: true,
      activeone: true,
      activetwo: false,
      activethree: false,
      dialogshow: false,
      red: "red",
      swipeDirection: false,
      attendance: "atten",
      items: [
        { category: "Present", value: "atten" },
        { category: "Absent", value: "absent" },
      ],

      AllCategory: 0,
      Pronunciation: [
        {
          title: "Student`s pronunciation is not good.",
          value: 1,
        },
        {
          title:
            "Student`s pronunciation is not good but student can pronounce some English words.",
          value: 2,
        },
        {
          title:
            "Student`s pronunciation is not that bad. Student can pronounce some words.\
                ",
          value: 3,
        },
        {
          title:
            "Student can pronounce common English words but finds it hard to speak uncommon words.\
                ",
          value: 4,
        },
        {
          title:
            "Student can pronounce common English words and student is familiar with difficult words.\
                ",
          value: 5,
        },
        {
          title:
            "Student can pronounce common and uncommon English words.\
                ",
          value: 6,
        },
        {
          title:
            "Student can pronounce many English words and student can easily remember new words.\
                ",
          value: 7,
        },
        {
          title:
            "Student can pronounce many English words and is familiar with difficult words.\
                ",
          value: 8,
        },
        {
          title: "Student can pronounce any word in English.\
                ",
          value: 9,
        },
      ],
      Grammar: [
        {
          title: "Student needs to know basic grammar.",
          value: 1,
        },
        {
          title: "Student knows a little about basic grammar.",
          value: 2,
        },
        {
          title:
            "Student knows about basic grammar but can`t apply it most of the time.",
          value: 3,
        },
        {
          title:
            "Student knows about basic grammar and can apply it sometimes.",
          value: 4,
        },
        {
          title: "Student mastered the basic grammar and applies it.",
          value: 5,
        },
        {
          title: "Student knows about basic and complex grammar.",
          value: 6,
        },
        {
          title:
            "Student knows about basic and complex grammar and student is applying it.",
          value: 7,
        },
        {
          title:
            "Student mastered grammar and student is always applying it in class.",
          value: 8,
        },
      ],
      Vocabulary: [
        {
          title:
            "The student`s vocabulary still needs improvement. It sometimes takes him a while to find the right words.",
          value: 1,
        },
        {
          title:
            "There were still struggles to find the right words. It is necessary for the student to search for ways to improve vocabulary.",
          value: 2,
        },
        {
          title:
            "The student is somehow able to come up with good words but further practice is necessary. It is very important for the student to continue improving vocabulary to aid speaking in English spontaneously.",
          value: 3,
        },
        {
          title:
            "The student know easy words to use when communicating in English. However, these easy and common words are not enough to aid student and to become more spontaneous.",
          value: 4,
        },
        {
          title:
            "The student is able to use correct words in answering. However, there is still a need to boost word skills. Checking on the synonyms and antonyms of easy words will be of great help.",
          value: 5,
        },
        {
          title:
            "The student uses good vocabulary when talking in class, but the student sometimes forgets some vocabulary words. Constant practice and determination in studying English vocabulary can help the student so much.",
          value: 6,
        },
        {
          title:
            "The student can produce good sentences because of the student's good vocabulary. The student will continue to develop if the student will continue to boost learning vocabulary.",
          value: 7,
        },
        {
          title:
            "The student can use words according to context. Vocabulary words being used are advanced.",
          value: 8,
        },
      ],
      Comprehension: [
        {
          title: "Student finds it hard to understand English.",
          value: 1,
        },
        {
          title: "Student finds it hard to understand English sometimes.",
          value: 2,
        },
        {
          title:
            "Student can understand the teacher but student finds it hard to understand difficult words.",
          value: 3,
        },
        {
          title:
            "Student can speak in English but student can only make very simple sentences with pauses.",
          value: 4,
        },
        {
          title: "Student can understand the teacher.",
          value: 5,
        },
        {
          title:
            "Student can understand the teacher regardless of the teacher`s pacing.",
          value: 6,
        },
        {
          title:
            "Student can understand the teacher even if the teacher talks really fast.",
          value: 7,
        },
      ],
      Fluency: [
        {
          title:
            "Student doesn`t speak English. Student is not fluent. Student can`t make complete sentences.",
          value: 1,
        },
        {
          title:
            "Student can speak little English and is always pausing. Student can`t make simple sentences.",
          value: 2,
        },
        {
          title:
            "Student can speak in English but finds it hard to explain to teacher. Student can construct phrases or clauses but not complete sentences",
          value: 3,
        },
        {
          title:
            "Student can understand the teacher but student can only understand common words.",
          value: 4,
        },
        {
          title:
            "Student can speak in English and can make simple to complex sentences with pauses.",
          value: 5,
        },
        {
          title:
            "Student can speak in English and can make complex and compound sentences but with minimal pauses.",
          value: 6,
        },
        {
          title:
            "Student can speak in English and can make complex and compound sentences without any pause.",
          value: 7,
        },
        {
          title:
            "Student can speak in English without any pause and can use uncommon words when talking in the class. Student can make complex sentences.",
          value: 8,
        },
        {
          title:
            "Student can speak English continuously and fluently. Student can make complex sentences without any difficulty.",
          value: 9,
        },
      ],
      prevStat: "",
      proVal: 0,
      pronun: 0,
      graVal: 0,
      gram: 0,
      volVal: 0,
      vocabul: 0,
      volca: 0,
      comVal: 0,
      compre: 0,
      fluen: 0,
      fluVal: 0,
      level: 0,
      levelNumber: 0,
      listgroup1: false,
      listgroup2: false,
      listgroup3: false,
      listgroup4: false,
      listgroup5: false,
      listgroup1error: false,
      listgroup2error: false,
      listgroup3error: false,
      listgroup4error: false,
      listgroup5error: false,
      word1: "",
      errorword1: false,
      errorword2: false,
      errormemo: false,
      errorWordcount1: 0,
      errorWordcount2: 0,
      word2: "",
      comment: "",
      memo: "",
      totalscores: 0,
      errorpro: "",
      mdi_close1: "",
      mdi_check1: "",
      mdi_check2: "",
      mdi_close2: "",
      e1: 1,
      audioVal1: "",
      audioAxios1: "",
      audioVal2: "",
      inputRules: [(v) => v.length >= 1 || "Item is Required"],
      radioRules: [(v) => !!v || "Item is Required! Please Select One Answer"],
      fetchmsgOnly: "",
      StudentData: "",
      StudentInfo: "",
      getResult: false,
      postTest: {
        action: "insertEval",
        l_id: "69713",
        id: "kuzco92",
        attendance: "atten",
        totalScore: 400,
        level: 2,
        feedBack: {
          correction: [
            {
              worng: "Nice",
              correct: "Statisfy",
            },
            {
              worng: "test",
              correct: "Correct",
            },
          ],
          word: ["World", "Hello"],
        },
        score: {
          pronunciation: {
            text: "pronunciation",
            value: 1,
          },
          grammar: {
            text: "grammar",
            value: 1,
          },
          vocabulary: {
            text: "vocabulary",
            value: 1,
          },
          comprehension: {
            text: "comprehension",
            value: 1,
          },
          fluency: {
            text: "fluency",
            value: 1,
          },
        },
        comment: "This is a Test",
        memo: "This is a Test",
      },
    };
  },

  computed: {
    posts() {
      return {
        action: this.$route.params.action == "edit" ? "editEval" : "insertEval",
        l_id: this.StudentData.l_id,
        id: this.StudentData.id,
        attendance: this.attendance != "" ? this.attendance : "absent",
        totalScore: this.totalscores != "" ? this.totalscores : "0",
        level: this.levelNumber != "" ? this.levelNumber : "0",
        feedBack: {
          correction: [
            {
              worng: this.mdi_close1 != "" ? this.mdi_close1 : "empty",
              correct: this.mdi_check1 != "" ? this.mdi_check1 : "empty",
            },
            {
              worng: this.mdi_close2 != "" ? this.mdi_close2 : "empty",
              correct: this.mdi_check2 != "" ? this.mdi_check2 : "empty",
            },
          ],
          word: [
            this.word1 != "" ? this.word1 : "empty",
            this.word2 != "" ? this.word2 : "empty",
          ],
        },
        score: {
          pronunciation: {
            text:
              this.attendance != "absent"
                ? this.Pronunciation[this.proVal - 1].title
                : "empty",
            value: this.proVal != "" ? this.proVal : "0",
          },
          grammar: {
            text:
              this.attendance != "absent"
                ? this.Grammar[this.graVal - 1].title
                : "empty",
            value: this.graVal != "" ? this.graVal : "0",
          },
          vocabulary: {
            text:
              this.attendance != "absent"
                ? this.Vocabulary[this.volVal - 1].title
                : "empty",
            value: this.volVal != "" ? this.volVal : "0",
          },
          comprehension: {
            text:
              this.attendance != "absent"
                ? this.Comprehension[this.comVal - 1].title
                : "empty",
            value: this.comVal != "" ? this.comVal : "0",
          },
          fluency: {
            text:
              this.attendance != "absent"
                ? this.Fluency[this.fluVal - 1].title
                : "empty",
            value: this.fluVal != "" ? this.fluVal : "0",
          },
        },
        comment: this.comment != "" ? this.comment : "empty",
        memo: this.memo,
      };
    },
  },
  mounted() {
    axios
      .get(
        "https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id=" +
          this.$route.params.l_id +
          "&action=studentInfo"
      )
      //.then(response=>console.warn(response.data))
      .then((response) => (this.StudentData = response.data));

    if (this.$route.params.action == "edit") {
      this.editStatusInfo();
    }
  },
  watch: {},
  methods: {
    scrollTop() {
      var el = document.querySelector(".scrollUp");
      el.scrollTop = 0;
    },

    async editStatusInfo() {
      await axios
        .get(
          "https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id=" +
            this.$route.params.l_id +
            "&action=levelResult"
        )
        // .then(response=>console.warn(response.data))
        .then((response) => (this.StudentInfo = response.data));

      await this.attendance;
      await this.totalscores;
      await this.proVal;
      await this.graVal;
      await this.volVal;
      await this.comVal;
      await this.fluVal;

      await this.pronun;
      await this.gram;
      await this.volca;
      await this.compre;
      await this.fluen;

      await this.mdi_close1;
      await this.mdi_check1;
      await this.mdi_close2;
      await this.mdi_check2;

      await this.word1;
      await this.word2;

      await this.comment;
      await this.memo;

      this.attendance = this.StudentInfo.evaluation.attendance;
      this.totalscores = this.StudentInfo.evaluation.totalScore;
      this.proVal = this.StudentInfo.evaluation.score.pronunciation.value;
      this.graVal = this.StudentInfo.evaluation.score.grammar.value;
      this.volVal = this.StudentInfo.evaluation.score.vocabulary.value;
      this.comVal = this.StudentInfo.evaluation.score.comprehension.value;
      this.fluVal = this.StudentInfo.evaluation.score.fluency.value;

      this.pronun = this.StudentInfo.evaluation.score.pronunciation.value;
      this.gram = this.StudentInfo.evaluation.score.grammar.value;
      this.volca = this.volVal = this.StudentInfo.evaluation.score.vocabulary.value;
      this.compre = this.StudentInfo.evaluation.score.comprehension.value;
      this.fluen = this.StudentInfo.evaluation.score.fluency.value;

      this.mdi_close1 = this.StudentInfo.evaluation.feedBack.correction[0].worng;
      this.mdi_close2 = this.StudentInfo.evaluation.feedBack.correction[1].worng;
      this.mdi_check1 = this.StudentInfo.evaluation.feedBack.correction[0].correct;
      this.mdi_check2 = this.StudentInfo.evaluation.feedBack.correction[1].correct;

      this.word1 = this.StudentInfo.evaluation.feedBack.word[0];
      this.word2 = this.StudentInfo.evaluation.feedBack.word[1];

      this.comment = this.StudentInfo.evaluation.comment;
      this.memo = this.StudentInfo.evaluation.memo;
    },

    reset() {
      this.attendance = "atten";
      this.e1 = 1;

      this.totalscores = 0;
      this.proVal = 0;
      this.graVal = 0;
      this.volVal = 0;
      this.comVal = 0;
      this.fluVal = 0;

      this.pronun = 0;
      this.gram = 0;
      this.volca = 0;
      this.compre = 0;
      this.fluen = 0;

      this.mdi_close1 = "";
      this.mdi_close2 = "";
      this.mdi_check1 = "";
      this.mdi_check2 = "";

      this.word1 = "";
      this.word2 = "";

      this.comment = "";
      this.memo = "";
    },

    absent() {
      if (this.attendance == "absent") {
        this.e1 = 3;
      }
    },
    scorepro(val) {
      this.totalscores -= this.proVal * 10; //last value
      this.totalscores += val * 10;
      this.proVal = val;
    },
    scoregra(val) {
      this.totalscores -= this.graVal * 10;
      this.totalscores += val * 10;
      this.graVal = val;
    },
    scorevol(val) {
      this.totalscores -= this.volVal * 10;
      this.totalscores += val * 10;
      this.volVal = val;
    },
    scorecom(val) {
      this.totalscores -= this.comVal * 10;
      this.totalscores += val * 10;
      this.comVal = val;
    },
    scoreflu(val) {
      this.totalscores -= this.fluVal * 10;
      this.totalscores += val * 10;
      this.fluVal = val;
    },
    totalScore() {
      return (this.totalscores = this.AllCategory * 10);
    },
    levelResult: function() {
      var totalScore = this.totalscores;
      if (totalScore <= 50) {
        this.levelNumber = 1;
        return (this.level = "Low Beginner");
      } else if (totalScore >= 51 && totalScore <= 100) {
        this.levelNumber = 2;
        return (this.level = "Beginner");
      } else if (totalScore >= 101 && totalScore <= 150) {
        this.levelNumber = 3;
        return (this.level = "High Beginner");
      } else if (totalScore >= 151 && totalScore <= 200) {
        this.levelNumber = 4;
        return (this.level = "Low Intermediate");
      } else if (totalScore >= 201 && totalScore <= 250) {
        this.levelNumber = 5;
        return (this.level = "Intermediate");
      } else if (totalScore >= 251 && totalScore <= 300) {
        this.levelNumber = 6;
        return (this.level = "High Intermediate");
      } else if (totalScore >= 301 && totalScore <= 350) {
        this.levelNumber = 7;
        return (this.level = "Pre Advanced");
      } else if (totalScore >= 351 && totalScore <= 400) {
        this.levelNumber = 8;
        return (this.level = "Advanced");
      } else if (totalScore >= 401 && totalScore <= 450) {
        this.levelNumber = 9;
        return (this.level = "Post Advanced");
      } else {
        return (this.level = " Undefined Level");
      }
    },
    onClickOne() {
      this.activeone = false;
    },
    onClickTwo() {
      this.activetwo = true;
    },
    submittest() {
      //    if(this.attendance=='absent'){
      //        if(this.memo){
      //           console.warn(this.posts)
      //         //   axios.post('https://phone.megatalking.com/origin/api/leveltest_evaluation.php',this.posts)
      //         //     .then((result)=>{
      //         //      console.log(result)
      //         //      }).catch(error=>console.log('this is the error '+error))
      //         this.$refs.leveltestDialog.open()

      //        } else {
      //             this.errormemo=true
      //        }

      //    } else {
      //        console.warn(this.posts)

      //     // axios.post('https://phone.megatalking.com/origin/api/leveltest_evaluation.php',this.posts)
      //     // .then((result)=>{
      //     //          console.log(result)
      //     // }).catch(error=>console.log('this is the error '+error))
      //     // this.$refs.leveltestDialog.open()
      //    }

      return (this.dialogshow = true);
    },
     async submit() {
            
                      if(this.attendance=='absent'){

                                 if(this.memo){
                                    console.warn(this.posts)
                                    axios.post('https://phone.megatalking.com/origin/api/leveltest_evaluation.php',this.posts)
                                        .then((result)=>{
                                       console.log(result);
                                        if(result){
                                            this.$refs.leveltestDialog.open()
                                        }
                                        }).catch(error=>console.log('this is the error '+error))
                                         this.$refs.leveltestDialog.open()
                                } else {
                                        this.errormemo=true
                                }



                      } else if (this.$refs.form.validate() && this.pronun > 0 && this.gram > 0 && this.volVal > 0 && this.comVal > 0 && this.fluVal >0) {
                                this.errorword1=false
                                this.errorword2=false
                                
                                await axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+this.word1).then(response => {this.audioVal1=response.data[0].phonetics[0].audio

                                       if(!this.audioVal1){
                                            this.audioVal1 = response.data[0].phonetics[1].audio
                                        }
                                
                                }).catch(
              (error) =>
                error ? this.getDefinition(this.word1,"audioVal1","errorword1") : ''
            );
                                await  axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+this.word2).then(response => {this.audioVal2=response.data[0].phonetics[0].audio

                                    if(!this.audioVal2){
                                            this.audioVal2 = response.data[0].phonetics[1].audio
                                        }
                                
                                }).catch(
              (error) =>
                error ? this.getDefinition(this.word2,"audioVal2","errorword2") : ''
            );    
                                
        
                                console.warn(this.errorword1)
                

                                if(this.errorword1==false && this.errorword2==false){
                                    
                                    axios.post('https://phone.megatalking.com/origin/api/leveltest_evaluation.php',this.posts)
                                    .then((result)=>{
                                        console.log(result);
                                        if(result){
                                            this.$refs.leveltestDialog.open()
                                        }
                                    }).catch(error=>console.log('this is the error '+error))
                                    
                                    
                                }
                        
                            } else
                                {
                                    if(this.mdi_close1 ==''){
                                        return this.e1=1
                                    }
                                    if(this.mdi_check1 == ''){
                                        return this.e1=1
                                    }
                                    if(this.mdi_close2 ==''){
                                        return this.e1=1
                                    }
                                    if(this.mdi_check2 == ''){
                                        return this.e1=1
                                    }
                                    if(this.word1 ==''){
                                        return this.e1=1
                                    }
                                    if(this.word2 == ''){
                                        return this.e1=1
                                    }
                                    if(this.pronun == 0){
                                        return this.e1=2,this.listgroup1 = true,this.listgroup1error=true
                                    }
                                    if(this.gram == 0){
                                        return this.e1=2,this.listgroup2 = true,this.listgroup2error=true
                                    }
                                    if(this.volVal == 0){
                                        return this.e1=2,this.listgroup3 = true,this.listgroup3error=true
                                    }
                                    if(this.comVal == 0){
                                        return this.e1=2,this.listgroup4 = true,this.listgroup4error=true
                                    }
                                    if(this.fluVal == 0){
                                        return this.e1=2,this.listgroup5 = true,this.listgroup5error=true
                                    }
                                }
 },
    openDialogtest() {
      return (this.dialogshow = true);
    },
    getDefinition(word,variable,errorword){
            axios
                .get(
                "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + word
                )
                .then(
                (response) =>{
                    
                    this[variable] =  response.data[0].meanings[0].definitions[0].definition
                    
                    
                    
                }).catch(
                (error) =>
                    error ? (this[errorword] = true) : (this[errorword] = false),
                (this.e1 = 1)
                );
             },
         async openDialog(){
             if(this.attendance!='absent'){

                    if (this.$refs.form.validate() && this.pronun > 0 && this.gram > 0 && this.volVal > 0 && this.comVal > 0 && this.fluVal >0) {
                            this.errorword1=false
                            this.errorword2=false
                            
                            await axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+this.word1).then(response => this.audioVal1=response.data[0].phonetics[0].audio).catch(
              (error) =>
                error ? this.getDefinition(this.word1,"audioVal1","errorword1") : ''
            );
                            await  axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+this.word2).then(response => this.audioVal2=response.data[0].phonetics[0].audio).catch(
              (error) =>
                error ? this.getDefinition(this.word2,"audioVal2","errorword2") : ''
            );   
                            
                
                            console.warn('fetch audio '+this.errorword1)
                            

                            if(this.errorword1==false && this.errorword2==false){
                                
                                this.$refs.leveltestDialog.open()
                            }
                                
                            } 
                            else
                            {
                            if(this.mdi_close1 ==''){
                                return this.e1=1
                            }
                            if(this.mdi_check1 == ''){
                                return this.e1=1
                            }
                            if(this.mdi_close2 ==''){
                                return this.e1=1
                            }
                            if(this.mdi_check2 == ''){
                                return this.e1=1
                            }
                            if(this.word1 ==''){
                                return this.e1=1
                            }
                            if(this.word2 == ''){
                                return this.e1=1
                            }
                            if(this.pronun == 0){
                                return this.e1=2,this.listgroup1 = true,this.listgroup1error=true
                            }
                            if(this.gram == 0){
                                return this.e1=2,this.listgroup2 = true,this.listgroup2error=true
                            }
                            if(this.volVal == 0){
                                return this.e1=2,this.listgroup3 = true,this.listgroup3error=true
                            }
                            if(this.comVal == 0){
                                return this.e1=2,this.listgroup4 = true,this.listgroup4error=true
                            }
                            if(this.fluVal == 0){
                                return this.e1=2,this.listgroup5 = true,this.listgroup5error=true
                            }
                            }


             } 
         },
    swipe(direction) {
      if (direction == "Left") {
        this.swipeDirection = true;
      } else if (direction == "Right") {
        this.swipeDirection = false;
      }
    },
  },
};
</script>
<style scoped>
@import url("../../../../assets/css/LevelTest/Forms/style.css");
</style>
<style scoped>
.monsterrat {
  font-family: "Montserrat", serif !important;
}
</style>

            